<template>
    <div>
        <b-card class="rounded sticky-top mb-1 overflow-hidden sticky-banner-behind-nav" no-body>
            <b-overlay :show="getting">
                <div class="row p-75 align-items-center">
                    <div class="col-md-auto mb-0">
                        <div class="rounded" :class="this.paidStatus != null ? (this.paidStatus == true ? 'bg-light-success' : 'bg-light-danger') : 'bg-light-warning'">
                            <h4 class="px-1 py-75 mb-0">
                                <b>İŞLEMDEKİ PERSONEL:</b>  &nbsp;<span :class="this.paidStatus != null ? (this.paidStatus == true ? 'text-success' : 'text-danger') : 'text-warning'">{{ getValue("FullName") }}</span>
                            </h4>
                        </div>
                    </div>
                    <div class="col-md-auto mb-0">
                        <div class="rounded" :class="this.paidStatus != null ? (this.paidStatus == true ? 'bg-light-success' : 'bg-light-danger') : 'bg-light-warning'">
                            <h4 class="px-1 py-75 mb-0">
                                <b>DÖNEM:</b>               &nbsp;<span :class="this.paidStatus != null ? (this.paidStatus == true ? 'text-success' : 'text-danger') : 'text-warning'">{{ getValue("PeriodInfo") }}</span>
                            </h4>
                        </div>
                    </div>
                    <div class="col-md-auto mb-0">
                        <div class="rounded" :class="this.paidStatus != null ? (this.paidStatus == true ? 'bg-light-success' : 'bg-light-danger') : 'bg-light-warning'">
                            <h4 class="px-1 py-75 mb-0">
                                <b>DURUMU:</b>              &nbsp;<span :class="this.paidStatus != null ? (this.paidStatus == true ? 'text-success' : 'text-danger') : 'text-warning'">{{ getValue("Status") }}</span>
                            </h4>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body class="rounded mb-1 overflow-hidden">
            <b-overlay :show="getting">
                <h4 class="px-1 pt-1 mb-0">Maaş Dönemi</h4>
                <div class="row p-1">
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{ m.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year">
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-primary" v-on:click="getList">Liste Sorgula</button>
                    </div>
                </div>
            </b-overlay>
        </b-card>

        <b-card no-body class="rounded mb-1 overflow-hidden">
            <b-overlay :show="getting" class="overflow-hidden">
                <div class="d-fex align-items-center row px-1 col-12">
                    <div class="col-10">
                        <h4 class="px-25 pt-1 mb-0">Personel Maaş Detayı</h4>
                    </div>
                </div>
                <div class="row p-1 align-items-center">
                    <!-- <div class="col-md-3 mb-1 mb-md-0">
                        <v-select-list :disabled="!queryable" :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Yaka"></v-select-list>
                    </div> -->
                    <div class="col-md-3 mb-1 mb-md-0">
                        <input class="form-control" v-model="identityNumber" placeholder="Kimlik Numarası" />
                    </div>
                    <div class="col-md-6">
                        <span v-b-tooltip.hover :title="!identityNumber ? 'Lütfen bir kimlik numarası giriniz.' : ''">
                            <button class="btn btn-primary" :disabled="!identityNumber" v-on:click="get" :class="{ 'disabled-cursor': !identityNumber }">Personel Sorgula</button>
                        </span>
                    </div>
                    <!-- <div class="col-md-1">
                        <button v-if="(this.collarStatus && this.identityNumber) || !queryable" class="btn btn-icon btn-outline-secondary ml-0" v-on:click="clearForm">
                            <feather-icon icon="RefreshCwIcon" />
                        </button>
                    </div> -->
                    <div class="col-md-3 d-flex justify-content-end">
                        <button v-if="requestedIdentity" class="btn btn-outline-dark mr-0" v-on:click="clearForm">
                            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                            Listeye Dön
                        </button>
                    </div>
                </div>
                <div v-if="requestedIdentity" class="p-1 border-top">
                    <div class="border rounded-lg overflow-hidden mb-1">
                        <div class="row bg-light border-bottom align-items-center px-75 mb-75">
                            <div class="col-md">
                                <h2 class="d-block align-middle mb-0 font-weight-bolder py-1">{{ getValue("FullName") }}</h2>
                            </div>
                            <div class="col-md-auto">
                                <button :class="['btn btn-block',!$safe(result, 'HasDeposits') ? 'btn-dark' : 'btn-secondary']" v-on:click="openDepositsModal" :disabled="!$safe(result, 'HasDeposits')">
                                    <feather-icon icon="ArchiveIcon" class="mr-50" />
                                    <span
                                        >Emanet: <strong>{{ totalDepositsStr }}</strong></span
                                    >
                                </button>
                            </div>
                            <div class="col-md-auto">
                                <button v-on:click="goToCariHesap" class="btn btn-primary btn-block">
                                    <feather-icon icon="ExternalLinkIcon" class="mr-50" />
                                    <span>Personele Ait Yıllık Cari Hesap</span>
                                </button>
                            </div>
                        </div>
                        
                        <div class="row px-75 pb-75">
                            <div class="col-md-6 mb-1">
                                <stats-box text="Şube" :value="getValue('OBranch')" icon="store" variant="info" />
                            </div>
                            <div class="col-md-6 mb-1">
                                <stats-box text="Görev Yeri" :value="getValue('Garage')" icon="place" variant="warning" />
                            </div>
                            <!-- <div class="col-md-4 mb-1">
                                <stats-box text="Sabit Maaş" :value="getValue('SalaryStr')" icon="attach_money" variant="success" />
                            </div> -->
                            <div class="col-md-4 mb-1">
                                <stats-box text="Giriş Tarihi" :value="getValue('EntryDate')" icon="login" variant="secondary" />
                            </div>
                            <div class="col-md-4 mb-1">
                                <stats-box text="Çıkış Tarihi" :value="getValue('ExitDate')" icon="logout" variant="secondary" />
                            </div>
                            <div class="col-md-4 mb-1">
                                <stats-box text="Çalışılan Gün" :value="getValue('WorkedDays')" icon="work_history" variant="primary" />
                            </div>
                            <div class="col-md-4 mb-1 mb-md-0">
                                <stats-box text="Yıllık İzin (Gün)" :value="getValue('YILLIK_IZIN_GUN')" icon="event_available" variant="primary" />
                            </div>
                            <div class="col-md-4 mb-1 mb-md-0">
                                <stats-box text="Ücretli İzin (Gün)" :value="getValue('UCRETLI_IZIN_GUN')" icon="event" variant="primary" />
                            </div>
                            <div class="col-md-4 mb-1 mb-md-0">
                                <stats-box text="Diğer Eksik Gün" :value="getValue('DIGER_EKSIK_GUN')" icon="event_busy" variant="primary" />
                            </div>
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col-md-6 d-flex flex-column">
                            <div class="border rounded-lg overflow-hidden d-flex flex-column h-100 w-100">
                                <h5 class="text-dark font-weight-bolder mb-75 px-1 py-75 d-flex align-items-center bg-light border-bottom">
                                    <feather-icon icon="FileTextIcon" size="20" class="mr-50" />
                                    Hakediş Dağılımı
                                </h5>
                                <div class="flex-grow-1 px-75 pb-75">
                                    <div class="border-bottom mb-75" v-if="$safe(result,'CollarStatusCode') == 'Driver'">
                                        <div
                                            class="d-flex align-items-center justify-content-between rounded mb-50 p-50 text-dark-white"
                                            :class="{ 'bg-muted': $safe(result, 'CalismaMaasi', 0) > 0, '-muted': $safe(result, 'CalismaMaasi', 0) == 0 }"
                                        >
                                            <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-success">looks_one</span>Çalışma Kazanç</div>
                                            <span class="font-weight-bolder">{{ getValue("CalismaMaasiStr") }}</span>
                                        </div>
                                        <div
                                            class="d-flex align-items-center justify-content-between rounded mb-75 p-50"
                                            :class="{ 'bg-muted': $safe(result, 'YILLIK_IZIN', 0) > 0, 'bg-lightest-muted': $safe(result, 'YILLIK_IZIN', 0) == 0 }"
                                        >
                                            <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-success">looks_one</span>Yıllık İzin Kazanç</div>
                                            <span :class="{ 'font-weight-bolder': $safe(result, 'YILLIK_IZIN', 0) > 0 }">{{ getValue("YILLIK_IZINStr") }}</span>
                                        </div>
                                    </div>
                                    <!-- <div class="d-flex align-items-center justify-content-between rounded mb-50 p-50" :class="{ 'bg-muted': $safe(result, 'MESAI', 0) > 0, 'bg-lightest-muted': $safe(result, 'MESAI', 0) == 0 }">
                                        <span><feather-icon icon="ClockIcon" class="mr-50" />Mesai Ücreti</span>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'MESAI', 0) > 0 }">{{ getValue("MESAIStr") }}</span>
                                    </div> -->
                                    <div class="d-flex align-items-center justify-content-between bg-light-warning text-dark-white rounded mb-50 p-50 border">
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Yemek Ücreti</div>
                                        <span class="font-weight-bolder">{{ getValue("YEMEKStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'YOL', 0) > 0, 'bg-lightest-muted': $safe(result, 'YOL', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Yol Ücreti</div>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'YOL', 0) > 0 }">{{ getValue("YOLStr") }}</span>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between bg-light-info rounded mb-50 p-50 text-dark-white border">
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Prim Ücreti</div>
                                        <span class="font-weight-bolder">{{ getValue("PRIMStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'DESTEK', 0) > 0, 'bg-lightest-muted': $safe(result, 'DESTEK', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Destek Primi</div>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'DESTEK', 0) > 0 }">{{ getValue("DESTEKStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'HAMMALIYE', 0) > 0, 'bg-lightest-muted': $safe(result, 'HAMMALIYE', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Hammaliye Bedeli</div>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'HAMMALIYE', 0) > 0 }">{{ getValue("HAMMALIYEStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'YATMA', 0) > 0, 'bg-lightest-muted': $safe(result, 'YATMA', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Yatma Bedeli</div>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'YATMA', 0) > 0 }">{{ getValue("YATMAStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'YAKIT_PRIMI', 0) > 0, 'bg-lightest-muted': $safe(result, 'YAKIT_PRIMI', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Yakıt Primi</div>
                                        <span :class="{ 'font-weight-bold': $safe(result, 'YAKIT_PRIMI', 0) > 0 }">{{ getValue("YAKIT_PRIMIStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'YAKIT_PRIMI', 0) > 0, 'bg-lightest-muted': $safe(result, 'YAKIT_PRIMI', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Sıfırlama</div>
                                        <span :class="{ 'font-weight-bold': $safe(result, 'YAKIT_PRIMI', 0) > 0 }">{{ getValue("SIFIRLAMAStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'BAYRAM_MESAISI', 0) > 0, 'bg-lightest-muted': $safe(result, 'BAYRAM_MESAISI', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Bayram Mesaisi</div>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'BAYRAM_MESAISI', 0) > 0 }">{{ getValue("BAYRAM_MESAISIStr") }}</span>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50"
                                        :class="{ 'bg-muted': $safe(result, 'DIGER', 0) > 0, 'bg-lightest-muted': $safe(result, 'DIGER', 0) == 0 }"
                                    >
                                        <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Diğer</div>
                                        <span :class="{ 'font-weight-bolder': $safe(result, 'DIGER', 0) > 0 }">{{ getValue("DIGERStr") }}</span>
                                    </div>
                                </div>

                                <div class="pt-75 px-75 pb-75"  v-if="$safe(result,'CollarStatusCode') == 'Driver'">
                                    <div class="bg-light-warning border-warning text-white rounded p-1">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <h5 class="font-weight-bolder mb-0"><feather-icon icon="FileTextIcon" class="mr-50" />Toplam Hakediş</h5>
                                            <h4 class="font-weight-bolder mb-0">{{ getValue("TOPLAM_HAKEDISStr") }}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 d-flex flex-column">
                            <div class="border rounded-lg overflow-hidden d-flex flex-column h-100 w-100">
                                <h5 class="text-dark font-weight-bolder bg-light px-1 py-75 mb-75 d-flex align-items-center border-bottom">
                                    <feather-icon icon="DollarSignIcon" size="20" class="mr-50" />
                                    Ödeme Dağılımı
                                </h5>

                                <div class="flex-grow-1 px-75 pb-75">
                                    <div v-if="$safe(result,'CollarStatusCode') == 'Driver'" class="border-success rounded-lg mb-75">
                                        <div class="d-flex align-items-center justify-content-between bg-light-success text-foreground px-1 py-50 text-dark-white">
                                            <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-success">looks_one</span>Banka 1</div>
                                            <span class="font-weight-bolder">{{ getValue("BANKA_1_ODENENStr") }}</span>
                                        </div>
                                        <div class="p-50">
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>Avans</div>
                                                <span class="font-weight-bolder">{{ getValue("BANKA_AVANSStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>BES</div>
                                                <span class="font-weight-bolder">{{ getValue("BESStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>Yemek Ücreti</div>
                                                <span class="font-weight-bolder">{{ getValue("YEMEKStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>Trafik Cezası <small>(Bu Ay/Kalan)</small></div>
                                                <span class="font-weight-bolder">{{ getValue("B1TrafikCezasiThisMonthStr") }} / {{ getValue("B1TrafikCezasiRemainingStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>İcra <small>(Bu Ay/Kalan)</small></div>
                                                <span class="font-weight-bold">{{ getValue("ICRAStr") }} / {{ getValue("ICRATOTALStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded p-50 bg-light-warning fs-125"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-warning">check_box</span>Bankaya Yatırılan</div>
                                                <span class="font-weight-bolder">{{ getValue("BANKAYA_YATANStr") }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="$safe(result,'CollarStatusCode') != 'Driver' && ($safe(result, 'B1TrafikCezasiThisMonth', 0) > 0 || $safe(result, 'B1TrafikCezasiRemaining', 0) > 0)" class="border-warning rounded-lg mb-75">
                                        <div class="d-flex align-items-center justify-content-between bg-light-warning text-foreground px-1 py-50 text-dark-white">
                                            <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-warning">looks_one</span>Banka 1 - Trafik Cezası</div>
                                        </div>
                                        <div class="p-50">
                                            <div class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted">
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>Trafik Cezası <small>(Bu Ay/Kalan)</small></div>
                                                <span class="font-weight-bolder">{{ getValue("B1TrafikCezasiThisMonthStr") }} / {{ getValue("B1TrafikCezasiRemainingStr") }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="border-info rounded-lg">
                                        <div class="d-flex align-items-center justify-content-between bg-light-info text-foreground px-1 py-50 text-dark-white">
                                            <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-info">looks_two</span>Banka 2</div>
                                            <span class="font-weight-bolder">{{ getValue("BANKA_2_TOTALStr") }}</span>
                                        </div>
                                        <div class="p-50">
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>Avans</div>
                                                <span class="font-weight-bolder">{{ getValue("BANKA_2_AVANSStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75">
                                                    <span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>
                                                    <span  class="material-icons-round d-block text-warning" v-if="$safe(result, 'TrafficFines.length')" v-b-tooltip.hover.html="trafficFinesTooltipContent">warning_amber</span>
                                                    Trafik Cezası <small>(Bu Ay / Toplam)</small>
                                                </div>
                                                <span class="font-weight-bold">{{ getValue("B2TrafikCezasiThisMonthStr") }} / {{ getValue("B2TrafikCezasiRemainingStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                            >
                                                <div class="d-flex align-items-center g-75">
                                                    <span class="material-icons-outlined d-block text-danger">indeterminate_check_box</span>
                                                    <span  class="material-icons-round d-block text-warning" v-if="$safe(result, 'IncidentInstallments.length')" v-b-tooltip.hover.html="incidentInstallmentsTooltipContent">warning_amber</span>
                                                    Vukuat <small>(Bu Ay/Kalan)</small>
                                                </div>
                                                <span class="font-weight-bold">{{ getValue("IncidentThisMonthStr") }} / {{ getValue("IncidentRemainingStr") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-light-warning fs-125"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-warning">exit_to_app</span>Tam Tutar</div>
                                                <span class="font-weight-bolder">{{ getValue("BANKA_2_A_Str") }}</span>
                                            </div>
                                            <div
                                                class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-light-warning fs-125"
                                            >
                                                <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-warning">exit_to_app</span>Küsürat</div>
                                                <span class="font-weight-bolder">{{ getValue("BANKA_2_B_Str") }}</span>
                                            </div>
                                            <div>
                                                <div class="d-flex align-items-center justify-content-between rounded p-50 bg-light-warning fs-125">
                                                    <div class="d-flex align-items-center g-75"><span class="material-icons-outlined d-block text-warning">check_box</span>Bakiye</div>
                                                    <div class="d-flex align-items-center g-75">
                                                        <span v-if="isWarningActive" class="font-weight-bolder">{{ getValue("BANKA_2Str") }}</span>
                                                        <v-currency-input v-else v class="form-control-sm" :value="banka2Bakiye_manual" v-on:update-value="(v) => (banka2Bakiye_manual = v)"/>
                                                        <button :class="['btn btn-sm btn-icon',isWarningActive ? 'btn-primary' : 'btn-secondary']" v-on:click="isWarningActive = !isWarningActive">
                                                            <feather-icon :icon="!isWarningActive ? 'XIcon' : 'Edit2Icon'" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="text-right mt-50" v-if="amountError">
                                                    <small class="text-danger">{{ amountError }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- <div
                                        class="d-flex align-items-center justify-content-between rounded mb-50 p-50 bg-lightest-muted"
                                        :class="isWarningActive ? 'border-durum-aktif' : 'border-durum-pasif'"
                                    >
                                        <span :class="isWarningActive ? 'text-dark' : 'text-muted'">
                                            <feather-icon icon="ActivityIcon" class="mr-50 align-middle font-weight-bolder" />
                                            <span class="align-middle font-weight-bolder">Durum</span>
                                        </span>

                                        <div class="d-flex align-items-center switch-neutral">
                                            <b-form-checkbox v-model="isWarningActive" switch></b-form-checkbox>
                                            <span class="ml-1 font-weight-bold" :class="isWarningActive ? 'text-dark' : 'text-muted'">
                                                {{ isWarningActive ? "Aktif" : "Pasif" }}
                                            </span>
                                        </div>
                                    </div> -->

                                    <!-- <div class="rounded p-1 mt-75" :class="isWarningActive ? 'bg-light-warning' : 'bg-light-primary'">
                                        <div class="d-flex align-items-center justify-content-between mb-50 text-dark-white">
                                            <h5 class="font-weight-bolder mb-0 text-warning"><feather-icon icon="HomeIcon" variant="warning" class="mr-50" />Banka 2</h5>
                                            <h5 class="font-weight-bolder mb-0 text-warning">{{ getValue("BANKA_2Str") }}</h5>
                                        </div>
                                        <div class="border-top border-warning my-75"></div>
                                        <div class="pl-2">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <span> <feather-icon icon="PlusCircleIcon" class="mr-50" /> Banka 2 Tam</span>
                                                <span class="font-weight-bold">{{ getValue("BANKA_2_A_Str") }}</span>
                                            </div>

                                            <div class="d-flex align-items-center justify-content-between my-50">
                                                <span> <feather-icon icon="PlusCircleIcon" class="mr-50" /> Banka 2 Küsürat</span>
                                                <span class="font-weight-bold">{{ getValue("BANKA_2_B_Str") }}</span>
                                            </div>

                                            <div class="d-flex align-items-center justify-content-between">
                                                <span> <feather-icon icon="RepeatIcon" class="mr-50" /> Banka 2 Bakiye</span>
                                                <span v-if="isWarningActive" class="font-weight-bold">{{ banka2BakiyeStr }}</span>
                                                <input v-else v-model.number="banka2Bakiye_manual" type="number" class="form-control form-control-sm w-50 text-right" placeholder="Tutar Giriniz" />
                                            </div>

                                            <div class="d-flex align-items-center justify-content-between mt-50">
                                                <span
                                                    ><feather-icon icon="ArrowLeftCircleIcon" class="mr-50" />
                                                    Önceki Aylardan Kalan Bakiye
                                                    <feather-icon
                                                        icon="InfoIcon"
                                                        size="16"
                                                        class="ml-50 align-middle cursor-pointer"
                                                        v-b-tooltip.hover.html.v-dark="{ customClass: 'wide-tooltip' }"
                                                        :title="previousMonthsTooltipContent"
                                                    />
                                                </span>
                                                <span class="font-weight-bold text-warning">{{ getValue("ONCEKI_AY_TOPLAM_TUTARStr", "0,00 ₺") }}</span>
                                            </div>
                                            <div v-if="!isBanka2BakiyeValid" class="text-right mt-25">
                                                <small class="text-danger d-block">
                                                    <feather-icon icon="AlertTriangleIcon" class="mr-25 align-middle"></feather-icon>
                                                    Girilen tutar, toplam Banka 2 tutarını aşamaz.
                                                </small>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>

                                <div class="px-75 pb-75">
                                    <div class="bg-light-warning border-warning text-white rounded p-1">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <h5 class="font-weight-bolder mb-0"><feather-icon icon="DollarSignIcon" class="mr-50" />Toplam Ödeme</h5>
                                            <h4 class="font-weight-bolder mb-0">{{ toplamOdemeStr }}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="$safe(result,'CollarStatusCode') == 'Driver'" class="row mt-2">
                        <div class="col-md-4 mb-1">
                            <stats-box icon="trending_up" text="Toplam Hakediş" :value="getValue('TOPLAM_HAKEDISStr')" variant="success" />
                        </div>
                        <div class="col-md-4 mb-1" >
                            <stats-box  icon="account_balance" text="Banka-1 Toplam" :value="getValue('BANKA_1_ODENENStr')" variant="info" />
                        </div>
                        <div class="col-md-4 mb-1">
                            <stats-box icon="account_balance_wallet" text="Banka-2 Toplam" :value="getValue('BANKA_2Str')" variant="primary" />
                        </div>
                    </div>
                    <!-- Beyaz yakalarda Toplam Hakediş, Banka-1 ve Banka-2 stats kutuları gizli -->
                    <!-- <div class="row">
                        <div class="col-md-4">
                            <v-stats-box 
                            text="Toplam Alacak" 
                            variant="success" 
                            icon="payments" 
                            :value="getValue('TotalCreditStr')"></v-stats-box>
                        </div>
                        <div class="col-md-4">
                            <v-stats-box 
                            text="Toplam Borç" 
                            variant="danger" 
                            icon="payments" 
                            :value="getValue('TotalDebtStr')"></v-stats-box>
                        </div>
                        <div class="col-md-4">
                            <v-stats-box 
                            text="Bakiye" 
                            variant="secondary" 
                            icon="account_balance_wallet" 
                            :value="getValue('OverallStr')"></v-stats-box>
                        </div>
                    </div> -->
                </div>
            </b-overlay>
        </b-card>

        <b-card no-body class="overflow-hidden mb-1" v-if="!requestedIdentity">
            <b-overlay :show="getting">
                <h4 class="p-1 mb-0">{{ periodHeader }}</h4>
                <table class="table table-sm bordered-header mb-0">
                    <thead>
                        <tr>
                            <th class="text-center w-10">Sıra No</th>
                            <th class="text-center w-30">TCKN</th>
                            <th class="text-center w-40">Ad Soyad</th>
                            <th class="text-center w-40">İşlem</th>
                        </tr>
                    </thead>
                    <tbody v-if="listData != null && listData.length > 0">
                        <tr :class="v.GSalaryPaymentId == gSalId ? 'bg-light-warning' : ''" v-for="v in listData" :key="v.OrderNumber">
                            <td>{{ v.OrderNumber }}</td>
                            <td>{{ v.IdentityNumber || "-" }}</td>
                            <td>{{ v.FullName || "-" }}</td>
                            <td>
                                <button class="btn btn-xs btn-icon btn-flat-secondary" v-on:click="getById(v.GSalaryPaymentId)">
                                    <feather-icon icon="ZapIcon" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="4">'Liste Sorgulama' yapınız.</td>
                        </tr>
                    </tbody>
                </table>
            </b-overlay>
        </b-card>
        <b-card no-body class="rounded">
            <b-overlay :show="getting">
                <div class="row p-1">
                    <div class="col">
                        <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                            <v-select-list v-model="kasa" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
                        </v-validator>
                    </div>
                    <div class="col-auto">
                        <span
                            class="d-inline-block"
                            v-b-tooltip.hover.html.v-dark="{ customClass: 'wide-tooltip' }"
                            :title="validationTooltipContent"
                            :class="{ 'disabled-cursor': !validationState.isValid }"
                        >
                            <v-executer :action="send" :loading="sending" :disabled="!validationState.isValid">Gönder</v-executer>
                        </span>
                    </div>

                    <div class="col-12 mt-25 text-danger d-flex justify-content-end" v-if="!validationState.isValid">
                        <small>
                            <feather-icon icon="AlertCircleIcon" size="14" class="align-middle" />
                            <span class="align-middle ml-25">{{ validationState.messages[0] }}</span>
                        </small>
                    </div>
                </div>
            </b-overlay>
        </b-card>

        <b-modal v-model="depositsModalVisible" size="lg" title="Emanet Kasa İşlemleri" no-close-on-backdrop hide-footer v-on:hidden="closeDepositsModal">
            <vault-action-form :initial-data="vaultFormInitialData" :deposits="$safe(result, 'Deposits', [])" v-on:saveSuccess="onDepositSaveSuccess" v-on:close="closeDepositsModal" />
        </b-modal>
    </div>
</template>

<script>
import { BCard, BOverlay, BFormCheckbox, BAlert, VBTooltip, BCollapse, VBToggle } from "bootstrap-vue";
import NetsisAccountantApi from "@/api/netsis-accountant";
import EmployeeOperationsApi from "@/api/employee-operations";
import IncidentOperationsApi from "@/api/incident-operations";
import NetsisOperationsApi from "@/api/netsis-operations";
import moment from "moment";
import StatsBox from "@/components/VStatsBox.vue";
import VaultActionForm from "./components/VaultActionForm.vue";
import VStatsBox from '@/components/VStatsBox.vue'
import VCurrencyInput from "@/components/VCurrencyInput.vue";

export default {
    components: {
        BCard,
        BOverlay,
        BAlert,
        StatsBox,
        BFormCheckbox,
        VaultActionForm,
        BCollapse,
        VStatsBox,
        VCurrencyInput
    },
    directives: {
        "b-tooltip": VBTooltip,
        "b-toggle": VBToggle,
    },
    data() {
        return {
            depositsModalVisible: false,
            collarStatuses: [],
            collarStatus: null,
            identityNumber: "",
            fullName: "",
            gSalId: null,
            amount: 0,
            getting: false,
            requestedIdentity: null,
            requestedCollarStatus: null,
            result: {},
            kasaList: [],
            kasaLoading: false,
            model: {
                EmployeeInformation: null,
                Amount: 0,
                VaultCode: null,
            },
            errors: {},
            sending: false,
            dataFilled: false,
            years: [],
            months: [
                { index: 1, name: "Ocak" },
                { index: 2, name: "Şubat" },
                { index: 3, name: "Mart" },
                { index: 4, name: "Nisan" },
                { index: 5, name: "Mayıs" },
                { index: 6, name: "Haziran" },
                { index: 7, name: "Temmuz" },
                { index: 8, name: "Ağustos" },
                { index: 9, name: "Eylül" },
                { index: 10, name: "Ekim" },
                { index: 11, name: "Kasım" },
                { index: 12, name: "Aralık" },
            ],
            donem: {
                year: moment().year(),
                month: moment().month() + 1,
            },
            paidStatus: null,
            payable: false,
            listData: null,
            queryable: false,
            isWarningActive: true,
            banka2A_manual: 0,
            banka2B_manual: 0,
            isBanka1KesintiCollapsed: true,
            banka2Bakiye_manual: null,
        };
    },
    mounted() {
        this.getCollarStatuses(), this.getKasaList(), this.configureYears(), this.getList();
    },
    methods: {
        getCollarStatuses() {
            NetsisAccountantApi.CurrentUsersAuthCollarStatuses().then((res) => {
                this.collarStatuses = res.data.Data;
            });
        },
        getValue(key = "", def = "-") {
            return this.requestedIdentity ? this.$safe(this.result, key) ?? def : "Sorgulama yapınız.";
        },
        get() {
            this.getting = true;
            this.banka2Bakiye_manual = null;
            this.isWarningActive = true;
            EmployeeOperationsApi.SearchByCollarStatusAndIdentity({
                CollarStatusId: this.collarStatus?.Id,
                IdentityNumber: this.identityNumber,
                Month: this.donem.month,
                Year: this.donem.year,
            })
                .then((res) => {
                    if (res.data.Success) {
                        this.requestedIdentity = this.identityNumber;
                        this.fullName = res.data.Data.FullName;
                        this.gSalId = res.data.Data.GSalaryPaymentId;
                        this.amount = res.data.Data.BANKA_2;
                        this.requestedCollarStatus = structuredClone(this.collarStatus);
                        this.result = res.data.Data || {};
                        this.banka2A_manual = res.data.Data.BANKA_2_A || 0;
                        this.banka2B_manual = res.data.Data.BANKA_2_B || 0;
                        this.dataFilled = true;
                        this.paidStatus = res.data.Data.Paid;
                        this.payable = res.data.Data.Payable;
                        this.queryable = true;
                    } else {
                        this.$result(res);
                        this.dataFilled = false;
                        this.paidStatus = null;
                        this.payable = false;
                    }
                    this.getting = false;
                })
                .catch((err) => {
                    this.getting = false;
                    this.$result(null, err);
                    this.dataFilled = false;
                    this.paidStatus = null;
                    this.payable = false;
                });
        },
        openDepositsModal() {
            if (this.result.Deposits && this.result.Deposits.length > 0) {
                this.selectedDeposit = this.result.Deposits[0];
            } else {
                this.selectedDeposit = null;
            }
            this.depositsModalVisible = true;
        },
        closeDepositsModal() {
            this.depositsModalVisible = false;
            this.selectedDeposit = null;
        },
        getById(id) {
            this.getting = true;
            this.banka2Bakiye_manual = null;
            this.isWarningActive = true;
            EmployeeOperationsApi.SearchByCollarStatusAndIdentity({
                Month: this.donem.month,
                Year: this.donem.year,
                GSalaryPaymentId: id,
            })
                .then((res) => {
                    if (res.data.Success) {
                        this.queryable = false;
                        var collarStatusIdOfSelectedEmployee = this.listData.find((s) => s.GSalaryPaymentId == res.data.Data.GSalaryPaymentId).CollarStatusId;
                        this.collarStatus = this.collarStatuses.find((cs) => cs.Id == collarStatusIdOfSelectedEmployee);
                        this.identityNumber = res.data.Data.IdentityNumber;
                        this.requestedCollarStatus = structuredClone(this.collarStatus);
                        this.requestedIdentity = this.identityNumber;
                        this.fullName = res.data.Data.FullName;
                        this.gSalId = res.data.Data.GSalaryPaymentId;
                        this.amount = res.data.Data.BANKA_2;
                        this.result = res.data.Data || {};
                        this.banka2A_manual = res.data.Data.BANKA_2_A || 0;
                        this.banka2B_manual = res.data.Data.BANKA_2_B || 0;
                        this.dataFilled = true;
                        this.paidStatus = res.data.Data.Paid;
                        this.payable = res.data.Data.Payable;
                    } else {
                        this.$result(res);
                        this.dataFilled = false;
                        this.paidStatus = null;
                        this.payable = false;
                    }
                    this.getting = false;
                })
                .catch((err) => {
                    this.getting = false;
                    this.$result(null, err);
                    this.dataFilled = false;
                    this.paidStatus = null;
                    this.payable = false;
                });
        },
        getList() {
            this.clearForm()
            this.getting = true;
            EmployeeOperationsApi.GetGSalaryListPaymentOrder(this.donem.month, this.donem.year)
                .then((res) => {
                    if (res.data.Success) {
                        this.listData = res.data.Data;
                    } else {
                    }
                    this.getting = false;
                })
                .catch((err) => {
                    this.getting = false;
                });
        },
        getKasaList() {
            this.kasaLoading = true;
            NetsisOperationsApi.GetKasaList()
                .then((res) => {
                    this.kasaList = res.data.Data;
                    this.kasaLoading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.kasaLoading = false;
                });
        },
        clearForm() {
            this.result = null;
            this.identityNumber = null;
            this.requestedIdentity = null;
            this.fullName = null;
            this.periodInfo = null;
            this.gSalId = null;
            this.collarStatus = null;
            this.amount = 0;
            this.model.VaultCode = null;
            this.paidStatus = null;
            this.payable = false;
            this.queryable = true;
            this.requestedCollarStatus = true;
            this.banka2Bakiye_manual = null;
            this.isWarningActive = true;
        },
        send() {
            this.sending = true;

            const balancePayload = {
                Amount: this.amount,
                Date: moment().format("YYYY-MM-DD"),
                EmployeeId: this.result.EmployeeId,
                B1: false,
            };

            const salaryPayload = {
                FullName: this.fullName,
                IdentityNumber: this.requestedIdentity,
                VaultCode: this.model.VaultCode,
                Amount: this.amount,
                GSalaryPaymentId: this.gSalId,
            };

            EmployeeOperationsApi.Balance.createSalary(balancePayload)
                .then((balanceResponse) => {
                    if (!balanceResponse.data.Success) {
                        throw new Error(balanceResponse.data.Message || "Bakiye kaydı oluşturulamadı.");
                    }
                    return NetsisAccountantApi.GMaas.Pay(salaryPayload);
                })
                .then((paymentResponse) => {
                    this.$result(paymentResponse);
                    if (paymentResponse.data.Success) {
                        this.get();
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.sending = false;
                });
        },
        configureYears() {
            let years = [];
            let year = moment().add(1,'year').format("YYYY");
            let firstYear = 1900;
            while (firstYear <= year) {
                years.push(firstYear++);
            }
            this.years = years.reverse();
        },
        onDepositSaveSuccess(vaultFormData) {
            if (!this.selectedDeposit || !this.selectedDeposit.Id) {
                this.$toast.error("İşlem yapılacak emanet kaydı bulunamadı.");
                return;
            }

            const payload = {
                IncidentDepositPaymentId: this.selectedDeposit.Id,
                Date: vaultFormData.EffectiveDate,
            };

            this.$setOverlay(true);
            IncidentOperationsApi.payDeposit(payload)
                .then((res) => {
                    this.$setOverlay(false);
                    this.$result(res);
                    if (res.data.Success) {
                        this.closeDepositsModal();
                        this.get();
                    }
                })
                .catch((err) => {
                    this.$setOverlay(false);
                    this.$result(null, err);
                });
        },
        
        goToCariHesap() {
            const targetPath = "/VaultOperations/EmployeeBalance";

            const url = this.$router.resolve({
                path: targetPath,
                query: {
                    employeeId: this.result.EmployeeId,
                    fullName: this.result.FullName,
                    identityNumber: this.result.IdentityNumber,
                },
            });
            window.open(url.href, "_blank");
        },
    },
    computed: {
        periodHeader() {
            if (!this.donem) return "Maaş Sırası";
            const monthName = this.months.find((m) => m.index == this.donem.month)?.name || "";
            return `${monthName} ${this.donem.year} Dönemi Maaş Sırası`;
        },
        banka1KesintilerTotalStr() {
            return ''
            // if (!this.result) return "0,00 ₺";
            // const dinamikKesintilerTotal = this.$safe(this.result, "B1Kesintiler", []).reduce((acc, kesinti) => acc + kesinti.Value, 0);

            // const besTotal = this.$safe(this.result, "BES", 0);
            // const icraTotal = this.$safe(this.result, "ICRA", 0);

            // const toplam = dinamikKesintilerTotal + besTotal + icraTotal;

            // return dinamikKesintilerTotal.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
        banka2KesintilerTotalStr() {
            if (!this.result) return "0,00 ₺";

            const avansTotal = this.$safe(this.result, "BANKA_2_AVANS", 0);
            const trafikCezaTotal = this.$safe(this.result, "B2_TRAFIK_CEZA", 0);
            const vukuatTotal = this.$safe(this.result, "INCIDENT", 0);

            const toplam = avansTotal + trafikCezaTotal + vukuatTotal;

            return toplam.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
        kasa: {
            get: function () {
                return this.kasaList.find((s) => s.KSMAS_KOD == this.model.VaultCode);
            },
            set: function (value) {
                this.model.VaultCode = value?.KSMAS_KOD || null;
            },
        },
        banka1KesintiTotalStr() {
            if (!this.$safe(this.result, "B1Kesintiler.length")) {
                return "0,00 ₺";
            }
            const total = this.result.B1Kesintiler.reduce((acc, kesinti) => acc + kesinti.Value, 0);
            return `${total.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
        },
        banka2BakiyeStr() {
            if (!this.result) return "0,00 ₺";

            const a = this.$safe(this.result, "BANKA_2_A", 0);
            const b = this.$safe(this.result, "BANKA_2_B", 0);
            const bakiye = a + b;

            return bakiye.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
        isBanka2BakiyeValid() {
            if (this.isWarningActive) return true;
            if (!this.banka2Bakiye_manual) return true;
            if (this.banka2Bakiye_manual > this.$safe(this.result, "BANKA_2", 0)) {
                return false;
            }
            return true;
        },
        previousMonthsTooltipContent() {
            const aylar = [
                { Ay: "Ocak", Borc: "150,00 ₺", Alacak: "0,00 ₺" },
                { Ay: "Şubat", Borc: "0,00 ₺", Alacak: "350,00 ₺" },
                { Ay: "Mart", Borc: "200,00 ₺", Alacak: "0,00 ₺" },
            ];

            const rows = aylar
                .map(
                    (ay) => `
                <tr>
                    <td class="text-left text-nowrap">${ay.Ay}</td>
                    <td class="text-right text-nowrap text-danger">${ay.Borc}</td>
                    <td class="text-right text-nowrap text-success">${ay.Alacak}</td>
                </tr>
            `
                )
                .join("");

            return `
            <table class="table table-sm table-bordered table-dark" style="margin-bottom: 0;">
                <thead>
                    <tr>
                        <th class="text-center text-nowrap">Ay</th>
                        <th class="text-center text-nowrap">Borç</th>
                        <th class="text-center text-nowrap">Alacak</th>
                    </tr>
                </thead>
                <tbody>
                    ${rows}
                </tbody>
            </table>
        `;
        },
        toplamOdemeRaw() {
            if (!this.result) return 0;

            const a = parseFloat(this.banka2A_manual) || 0;
            const b = parseFloat(this.banka2B_manual) || 0;
            return a + b;
        },
        toplamOdemeStr() {
            return this.toplamOdemeRaw.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
        totalDepositsStr() {
            if (!this.result || !this.$safe(this.result, "HasDeposits")) {
                return "Yok";
            }
            const total = (this.result.Deposits || []).reduce((acc, deposit) => acc + deposit.Amount, 0);
            return total.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
        vaultFormInitialData() {
            if (!this.result) return {};
            if (!this.result.Deposits || this.result.Deposits.length === 0) return {};

            const allRefNumbers = this.result.Deposits.map((d) => d.RefNumber).join(", ");
            const newDescription = `Vukuat Emanet Para Tahsilatı: ${this.$safe(this.result, "FullName")} - ${allRefNumbers}`;
            const amountToPay = this.selectedDeposit ? this.selectedDeposit.Amount : this.result.Deposits[0].Amount;

            return {
                Amount: amountToPay,
                VaultDescription: newDescription,
                TMSVaultDescription: newDescription,
                VaultActionType: "G",
                ProjectCode: "G",
                EffectiveDate: moment().format("YYYY-MM-DD"),
            };
        },
        hasPendingDeposits() {
            return this.$safe(this.result, "HasDeposits", false);
        },
        validationState() {
            const messages = [];

            if (!this.dataFilled) {
                messages.push("Önce personel sorgulaması yapılmalıdır.");
            } else {
                if (!this.identityNumber) messages.push("Personel kimlik numarası alanı boş olamaz.");
                // if (!this.collarStatus) messages.push("Yaka durumu seçilmemiştir.");
                if (!this.kasa) messages.push("Lütfen bir kasa seçimi yapınız.");
                if (this.$safe(this.result, "ONCEKI_AY_TOPLAM_TUTAR", 0) > 0) {
                    messages.push("Önceki aylardan devreden bakiye varken bu ay için ödeme yapılamaz.");
                }
                if (this.hasPendingDeposits) messages.push("Personele ait ödenmemiş emanetler bulunmaktadır.");
                if (!this.isWarningActive && this.banka2Bakiye_manual > this.$safe(this.result, "BANKA_2", 0)) {
                    messages.push("Banka 2 Bakiye, toplam Banka 2 tutarını aşamaz.");
                }
                if (!this.payable) messages.push("Maaş, ödemeye uygun durumda değildir (Kilitlenmemiş).");
            }

            return {
                isValid: messages.length === 0,
                messages: messages,
            };
        },
        validationTooltipContent() {
            if (this.validationState.isValid) return "";

            const listItems = this.validationState.messages.map((msg) => `<li>${msg}</li>`).join("");
            return `
            <div class="text-left p-25">
                <ul class="pl-1 mb-0">
                    ${listItems}
                </ul>
            </div>
        `;
        },
        amountError(){
            if (!this.isWarningActive && this.banka2Bakiye_manual > this.$safe(this.result, "BANKA_2", 0)) {
                    return "Banka 2 Bakiye, toplam Banka 2 tutarını aşamaz.";
                }else return null
        },
        trafficFinesTooltipContent() {
            if (!this.$safe(this.result, "TrafficFines.length")) {
                return "Detay bulunamadı.";
            }

            const rows = this.result.TrafficFines.map(
                (fine) => `
                    <tr>
                        <td class="text-center text-nowrap">${fine.ReportNumber}</td>
                        <td class="text-right text-nowrap">${fine.AmountStr}</td>
                    </tr>
                `
            ).join("");

            return `
                <table class="table table-sm table-bordered table-dark" style="margin-bottom: 0;">
                    <thead>
                        <tr>
                            <th class="text-center text-nowrap">Tutanak No</th>
                            <th class="text-center text-nowrap">Tutar</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                    </tbody>
                </table>
            `;
        },

        incidentInstallmentsTooltipContent() {
            if (!this.$safe(this.result, "IncidentInstallments.length")) {
                return "Detay bulunamadı.";
            }

            const rows = this.result.IncidentInstallments.map(
                (inc) => `
                    <tr>
                        <td class="text-center text-nowrap">${inc.RefNumber}</td>
                        <td class="text-center text-nowrap">${inc.InstallmentOrder} / ${inc.TotalInstallmentsCount}</td>
                        <td class="text-right text-nowrap">${inc.AmountStr}</td>
                    </tr>
                `
            ).join("");

            return `
                <table class="table table-sm table-bordered table-dark" style="margin-bottom: 0;">
                     <thead>
                        <tr>
                            <th class="text-center text-nowrap">Referans No</th>
                            <th class="text-center text-nowrap">Taksit</th>
                            <th class="text-center text-nowrap">Tutar</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                    </tbody>
                </table>
            `;
        },
    },
    watch: {
        isWarningActive(newValue) {
            if (newValue === true) {
                if (this.result) {
                    this.banka2A_manual = this.result.BANKA_2_A || 0;
                    this.banka2B_manual = this.result.BANKA_2_B || 0;
                } else {
                    this.banka2A_manual = 0;
                    this.banka2B_manual = 0;
                }
            } else {
                if (this.result && this.result.BANKA_2) {
                    const totalBanka2 = this.result.BANKA_2;
                    const apiBanka2A = this.result.BANKA_2_A || 0;
                    let newBanka2A = 0;
                    if (apiBanka2A > totalBanka2) {
                        newBanka2A = Math.round(totalBanka2 / 50) * 50;
                    } else {
                        newBanka2A = Math.round(apiBanka2A / 50) * 50;
                    }
                    const newBanka2B = parseFloat((totalBanka2 - newBanka2A).toFixed(2));
                    this.banka2A_manual = newBanka2A;
                    this.banka2B_manual = newBanka2B;
                }
            }
        },
    },
};
</script>

<style>
.text-dark-white {
    color: #5e5873 !important;
}
.dark-layout .text-dark-white {
    color: white !important;
}
.bg-muted {
    background-color: #f2f2f2 !important;
    border-color: rgba(151, 151, 151, 0.678);
    border-style: dashed;
    border-width: 1px;
}

.dark-layout .bg-muted {
    background-color: #24273065 !important;
    border-color: #4f5d70;
}

.bg-lightest-muted {
    background-color: #f9f9f9 !important;
    border-color: #eaeaea;
    border-style: solid;
    border-width: 1px;
}

.dark-layout .bg-lightest-muted {
    background-color: #3b425365 !important;
    border-color: #434b56;
}

.border-durum-aktif {
    border: 2px solid #3a3838 !important;
}
.border-durum-pasif {
    border: 2px solid #a9a9a9 !important;
}

.switch-neutral .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #3a3838;
}
.switch-neutral .custom-control-input:not(:checked) ~ .custom-control-label::before {
    background-color: #a9a9a9;
    border-color: #a9a9a9;
}
.sticky-banner-behind-nav {
    z-index: -1;
}
.wide-tooltip .tooltip-inner {
    max-width: none;
    padding: 0;
    background: #20242d;
    border-radius: 6px;
}
.transition-transform {
    transition: transform 0.3s ease;
}
.rotate-180 {
    transform: rotate(180deg);
}
.disabled-cursor {
    cursor: not-allowed;
}
.fs-125{
    font-size: 1.25rem;
}
</style>
